import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { $app } from "@app/app.service";
import { Subscription } from 'rxjs';

@Component({
    selector: 'layout-app-basic',
    template: ''
})
export class AppBasicLayout implements OnInit {

    console: boolean = $app.core.modeDevel;
    logPrefix: string = '@layout - '+ this.constructor.name;

    $app = $app; //for use in template

    listener: Subscription;

    constructor() {

        if (this.console) console.log(this.logPrefix, 'constructor');

        if( $app.core.appData?.currentLayout){

            $app.core.appData.currentLayout = this.constructor.name;
        }


        this.setListener();
    }

    ngOnInit(): void {

        if(this.console) console.log( this.logPrefix, 'init' );
    }

    ngOnDestroy() {

        if(this.listener) this.listener.unsubscribe();
    }

    setListener() {

        if(this.console) console.log( this.logPrefix, 'setListener' );

    }

    setup() {

        if(this.console) console.log( this.logPrefix,  'setup' );
    }

    initListener(){

        this.listener = new Subscription();
    }

}